import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import AuthCard from "../../components/AuthCard";
import { verifyEmail } from "../../lib/auth";

export default function Verify() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setError("Invalid or missing verification token");
      setLoading(false);
      return;
    }

    handleVerification(token);
  }, [searchParams]);

  const handleVerification = async (token) => {
    try {
      const result = await verifyEmail(token);
      setSuccess(result.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AuthCard
        title="Verifying Email"
        description="Please wait while we verify your email address"
      >
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
          <p className="text-sm text-gray-600">
            Verifying your email address...
          </p>
        </div>
      </AuthCard>
    );
  }

  if (error) {
    return (
      <AuthCard
        title="Verification Failed"
        description="We couldn't verify your email address"
      >
        <div className="text-center">
          <div className="text-red-600 text-6xl mb-4">⚠️</div>
          <p className="text-sm text-gray-600 mb-6">{error}</p>
          <div className="space-y-3">
            <a
              href="/#/contractor/sign-up"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
            >
              Create New Account
            </a>
            <a
              href="/#/contractor/sign-in"
              className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
            >
              Try to Sign In
            </a>
          </div>
        </div>
      </AuthCard>
    );
  }

  return (
    <AuthCard
      title="Email Verified!"
      description="Your email has been successfully verified"
    >
      <div className="text-center">
        <div className="text-green-600 text-6xl mb-4">✓</div>
        <p className="text-sm text-gray-600 mb-6">{success}</p>
        <div className="space-y-3">
          <a
            href="/#/contractor/sign-in"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
          >
            Sign In to Your Account
          </a>
          <p className="text-xs text-gray-500">
            You can now sign in and access all contractor features
          </p>
        </div>
      </div>
    </AuthCard>
  );
}
